import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en/translation.json';
import fr from '../locales/fr/translation.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
};

// 从 localStorage 读取保存的语言，如果没有则使用默认语言 'en'
const savedLanguage = localStorage.getItem('i18nextLng') || 'en';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage, // 从 localStorage 读取或使用默认语言
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // react 已经安全转义
  },
  supportedLngs: ['en', 'fr'],
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
});

export default i18n;
